import React from 'react';
import lazyGettext from 'js-utils/lazy-gettext';
import {
    ACCOUNT_SETTINGS_URL,
    CUSTOM_PRICING,
    FINE_PRINT_WITH_FIXED_FEE,
    PACKAGE_ONE,
    PACKAGE_ONE_NAME,
    PACKAGE_THREE,
    PACKAGE_THREE_NAME,
    PACKAGE_TWO,
    PACKAGE_TWO_NAME,
    PER_PAID_TICKET_TEXT,
} from '../../constants/main';
import {
    PACKAGE_ONE_FEATURES,
    PACKAGE_THREE_FEATURES,
    PACKAGE_TWO_FEATURES_ALL,
} from '../../constants/features';
import {
    STYLE_FILL,
    STYLE_NEUTRAL,
} from 'eventbrite_design_system/button/constants';

import AssortmentsEssentialsSimpleIllustrationSvg from 'eventbrite_design_system/iconography/icons/AssortmentsEssentialsSimpleIllustration';
import AssortmentsProfessionalSimpleIllustrationSvg from 'eventbrite_design_system/iconography/icons/AssortmentsProfessionalSimpleIllustration';
import AssortmentsPremiumSimpleIllustrationSvg from 'eventbrite_design_system/iconography/icons/AssortmentsPremiumSimpleIllustration';

export default {
    breadcrumbs: {
        crumbs: [
            {
                path: ACCOUNT_SETTINGS_URL,
                label: lazyGettext('Account Settings'),
            },
            {
                path: '#',
                label: lazyGettext('Change Package'),
            },
        ],
    },
    packagesList: {
        heading: lazyGettext('Change your package'),
        packages: {
            [PACKAGE_ONE]: {
                name: PACKAGE_ONE_NAME,
                illustration: <AssortmentsEssentialsSimpleIllustrationSvg />,
                description: lazyGettext(
                    'The essentials you need to start selling tickets in minutes.',
                ),
                priceDescription: lazyGettext('Free for free tickets'),
                features: PACKAGE_ONE_FEATURES,
                secondaryCTA: lazyGettext(`Learn about ${PACKAGE_ONE_NAME}`),
                dataAutomation: 'change-plan-downgrade-button',
                isProminentPackage: false,
                logoBgColor: 'grey-900',
                logoImg: 'pricing/logo-essentials',
                logoWidth: 142,
                logoHeight: 35,
            },
            [PACKAGE_TWO]: {
                name: PACKAGE_TWO_NAME,
                illustration: <AssortmentsProfessionalSimpleIllustrationSvg />,
                description: lazyGettext(
                    'A powerful solution to boost sales and grow your business.',
                ),
                priceDescription: lazyGettext('Free for free tickets'),
                includeOtherFeatures: true,
                features: PACKAGE_TWO_FEATURES_ALL,
                secondaryCTA: lazyGettext(`Learn about ${PACKAGE_TWO_NAME}`),
                dataAutomation: 'change-plan-upgrade-button',
                isProminentPackage: true,
                logoBgColor: 'ui-orange',
                logoImg: 'pricing/logo-professional',
                logoWidth: 257,
                logoHeight: 30,
            },
            [PACKAGE_THREE]: {
                name: PACKAGE_THREE_NAME,
                illustration: <AssortmentsPremiumSimpleIllustrationSvg />,
                description: lazyGettext(
                    'Tailored partnership for organizers with large and complex events.',
                ),
                includeOtherFeatures: true,
                priceDescription: CUSTOM_PRICING,
                features: PACKAGE_THREE_FEATURES,
                secondaryCTA: lazyGettext(`Learn about ${PACKAGE_THREE_NAME}`),
                isProminentPackage: false,
                logoBgColor: 'white',
                logoImg: 'pricing/logo-premium',
                logoWidth: 155,
                logoHeight: 61,
            },
        },
        CTAs: [
            lazyGettext('Downgrade'),
            lazyGettext('Upgrade'),
            lazyGettext('Contact us'),
        ],
        CTAStyles: [STYLE_NEUTRAL, STYLE_FILL, STYLE_NEUTRAL],
        perPaidTicketText: PER_PAID_TICKET_TEXT,
        finePrint: FINE_PRINT_WITH_FIXED_FEE,
    },
};
